import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ModalComponent } from '../../../../../shared/components/modal/modal.component';
import { PaymentMethodType } from '../../../../../services/purchase-form.service';
import { TranslateModule } from '@ngx-translate/core';
import { Utility } from '../../../../../services/utility/util';


export interface PaymentOption {
    value: PaymentMethodType;
    label: string;
    icon: string;
}

@Component({
    selector: 'app-payment-selection-modal',
    standalone: true,
    imports: [ModalComponent, TranslateModule],
    templateUrl: './payment-selection-modal.component.html',
    styleUrls: ['./payment-selection-modal.component.css'],
})
export class PaymentSelectionModalComponent {
    @Input() isOpen: boolean = false;
    @Input() currentMethod: PaymentMethodType | null = null;

    @Output() paymentMethodChanged = new EventEmitter<PaymentMethodType>();
    @Output() close = new EventEmitter<void>();

    paymentOptions: PaymentOption[] = [
        { value: PaymentMethodType.FRISBII_VIPPS, label: 'MobilePay', icon: 'assets/icons/MobilePayIcon.png' },
        { value: PaymentMethodType.ApplePay, label: 'Apple Pay', icon: 'assets/icons/ApplePayIcon.png' },
        { value: PaymentMethodType.PaymentCard, label: 'web.purchasePaymentCard', icon: 'assets/icons/CreditCardIcon.png' }
    ];

    constructor() {
        const isAndroid = Utility.isUserAndroid();
        if (isAndroid) {
            this.paymentOptions = this.paymentOptions.filter(option => option.value !== PaymentMethodType.ApplePay);
        }
    }

    selectMethod(method: PaymentMethodType): void {
        this.currentMethod = method;
        this.paymentMethodChanged.emit(method);
        this.onClose()
    }

    onClose(): void {
        this.close.emit();
    }
}
